module.exports = __webpack_public_path__ + "static/media/facebook.946039d1.svg";